//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'
import { createFieldConfig } from '../../components/QSelectUtils.js'
import { requestRoadsObjectsSearch } from '../RequestRoadsCommand/RequestRoadsCommandObjectsSearch.js'

export default {
  mixins: [requestRoadsObjectsSearch],
  props: {
    request: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      assetStateFieldConfig: createFieldConfig({ allRecordsFn: this.getAssetStates }),
      departmentseFieldConfig: createFieldConfig({ allRecordsFn: this.getDepartments })
    }
  },
  computed: {
    requestRoads: function () {
      return this.request.roadsRequest
    }
  },
  methods: {
    onCreateToWorkOnly: function () {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const data = {
        requestId: this.request.requestId,
        toWorkOnly: true
      }

      return axiosPost({
        url: '/vis/createRequestRoadsV2/onetouch',
        data: data,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное взятие заявки в работу',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка взятия заявки в работу'
      }).finally(() => {
        this.$emit('update')
        this.$q.loading.hide()
      })
    },
    onSendEmailToTransmit: function () {
      const warnings = ['В Roads будет отправлено письмо с запросом перевода на другого исполнителя', 'Текст письма сохранится в комментариях заявки']

      this.$d_ask({
        callback: data => {
          this.sendEmailToTransmit(data.reason)
        },
        header: 'Перевести заявку в Roads?',
        propsConfig: {
          reason: { type: 'text', label: 'Текст письма', required: true }
        },
        warning: warnings
      })
    },
    sendEmailToTransmit: function (messageText) {
      const data = {
        requestId: this.request.requestId,
        messageText: messageText
      }

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosPost({
        url: '/vis/sendEmailToTransmitRequestRoads/onetouch',
        data: data,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Письмо для перевода на другого исполнителя отправлено',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка отправки письма для перевода на другого исполнителя'
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    onChangeDepartment: function () {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.changeDepartment(data)
          }
        },
        header: 'Перевести на другого исполнителя?',
        propsConfig: {
          description: {
            type: 'text',
            label: 'Рабочая информация',
            required: true
          },
          department: {
            label: 'Отдел',
            type: 'object',
            required: true,
            searchConfig: this.departmentseFieldConfig
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    changeDepartment: function (data) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const requestData = {
        requestId: this.request.requestId,
        description: data.description,
        departmentId: data.department
      }

      return axiosPost({
        url: '/vis/changeDepartmentRequestInRoads/onetouch',
        data: requestData,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешный перевод на другого исполнителя',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка перевода на другого исполнителя'
      }).finally(() => {
        this.$emit('update')
        this.$q.loading.hide()
      })
    },
    onRework: function () {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.rework(data)
          }
        },
        header: 'На доработку?',
        propsConfig: {
          assetState: {
            label: 'Состояние оборудования',
            type: 'object',
            required: true,
            searchConfig: this.assetStateFieldConfig
          },
          reworkDescr: {
            type: 'text',
            label: 'Описание доработки',
            required: true
          },
          reworkDate: {
            type: 'datetime',
            label: 'Дата/время отправки на доработку',
            required: true
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    rework: function (data) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const requestData = {
        requestId: this.request.requestId,
        assetState: data.assetState,
        reworkDescr: data.reworkDescr,
        reworkDate: data.reworkDate
      }

      return axiosPost({
        url: '/vis/reworkRequestInRoads/onetouch',
        data: requestData,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешная отправка на доработку',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка отправки на доработку'
      }).finally(() => {
        this.$emit('update')
        this.$q.loading.hide()
      })
    }
  }
}

